import React from "react";
import { Link } from "react-router-dom";
import { FEATURED_TOOL_LINKS } from "../tools/featuredLinks";
import BrandLogo from "./BrandLogo";

type SiteTopNavProps = {
  className?: string;
};

export default function SiteTopNav({ className = "" }: SiteTopNavProps) {
  return (
    <header
      className={`sticky top-0 z-40 border-b-2 border-[#111111] bg-white/95 backdrop-blur ${className}`.trim()}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-4 sm:px-6 lg:px-8">
        <Link
          to="/"
          aria-label="No Gatekeeping home"
          className="inline-flex shrink-0 items-center text-[#111111]"
        >
          <BrandLogo className="h-10 w-auto sm:hidden" variant="vertical" />
          <BrandLogo className="hidden h-7 w-auto sm:block" />
        </Link>

        <nav className="flex items-center gap-4 text-[11px] font-bold uppercase tracking-[0.18em] text-[rgba(17,17,17,0.68)] sm:gap-6">
          <Link className="transition-colors hover:text-[#111111]" to="/">
            Home
          </Link>
          <Link className="transition-colors hover:text-[#111111]" to="/tools">
            All Tools
          </Link>
          <Link className="hidden transition-colors hover:text-[#111111] sm:inline" to="/image-tools">
            Image Tools
          </Link>
          {FEATURED_TOOL_LINKS.map((tool) => (
            <Link
              key={tool.slug}
              className="hidden transition-colors hover:text-[#111111] xl:inline"
              to={`/tools/${tool.slug}`}
            >
              {tool.label}
            </Link>
          ))}
          <Link className="transition-colors hover:text-[#111111]" to="/blog">
            Blog
          </Link>
          <Link className="hidden transition-colors hover:text-[#111111] sm:inline" to="/about">
            About
          </Link>
        </nav>
      </div>
    </header>
  );
}
